import { useEffect, useRef } from 'react';
import { useSearchParams, useNavigate, useLocation } from 'react-router-dom';
import { toast } from 'sonner';

/** Shows a toast when user lands after sign-in with a non-admin role (redirected from OAuth). */
export function SignInFeedback() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const location = useLocation();
  const didToast = useRef(false);

  useEffect(() => {
    const signedIn = searchParams.get('signed_in');
    const role = searchParams.get('role');
    if (signedIn !== '1' || !role || role === 'admin') return;
    if (didToast.current) return;
    didToast.current = true;
    toast.info(
      "You're signed in. Admin access is by invitation only—contact your administrator if you need access.",
      { duration: 6000 }
    );
    navigate(location.pathname, { replace: true });
  }, [searchParams, navigate, location.pathname]);

  return null;
}
